// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__Rcb8u","title":"FrontImage_title__qYnlb"};